var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-view" }, [
    _c("div", { staticClass: "main-content" }, [
      _c(
        "div",
        { staticClass: "section" },
        [
          _c(
            "el-form",
            {
              staticStyle: { height: "100%" },
              attrs: {
                "label-width": "50px",
                "label-position": "right",
                inline: ""
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Menu.Search") } },
                [
                  _c("cargo-advance-select", {
                    ref: "tenantSel",
                    staticStyle: { width: "200px" },
                    attrs: {
                      "select-type": _vm.selectTypeNames.TENANT,
                      cache: false,
                      filterable: "",
                      "custom-label": _vm.companyLabel,
                      "callback-params": { key: "relateTenantId" },
                      "callback-method-type": "value",
                      "default-value": String(_vm.txtSearch) || ""
                    },
                    on: { parentCallBack: _vm.tenantIdChangeHandler }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "5px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.searchHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("Menu.Search")))]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "5px" },
                      attrs: { type: "danger" },
                      on: { click: _vm.removeHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("Menu.delete")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "section grid-wrapper" },
        [
          _c("cargo-ag-grid", {
            attrs: {
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }